import { h, Fragment } from 'preact';

import { GlobalState } from '../../../states/global-state';

import {
  effect,
  useComputed,
  useSignal,
  useSignalEffect,
} from '@preact/signals';

type BirthdateProps = {
  age: {
    name: string;
    placeholder: string;
    label: string;
    type: string;
    validator?: string;
    value?: string;
  };
  birthdate: {
    name: string;
    placeholder: string;
    label: string;
    type: string;
    validator?: string;
    value?: any;
  };
};
const moment = window['moment'];
const Birthdate = (props: BirthdateProps) => {
  const age: any = useComputed(() => {
    if (birthday.value) {
      const age = moment().diff(birthday.value, 'years');
      return age && age < 100 && age > 0 ? age + 1 : '';
    }
    return '';
  });

  const birthday: any = useSignal('');
  const isLoaded = useSignal(false);

  useSignalEffect(() => {
    const kycLoad = GlobalState.kycLoad.value;

    if (kycLoad && Object.keys(kycLoad).length && !isLoaded.value) {
      const value = moment(kycLoad[props.birthdate.name]);

      if (!value.isValid()) {
        return;
      }

      const date = moment(value).format('YYYY-MM-DD');

      birthday.value = date;
      isLoaded.value = true;
    }
  });

  const handleChange = e => {
    birthday.value = e.target.value;
  };

  return (
    <Fragment>
      <div class="form-floating mb-3 form-group" key={props.age['id']}>
        <input
          value={age}
          type={props.age.type}
          class="form-control input"
          id={props.age.name}
          name={props.age.name}
          placeholder={props.age.placeholder}
          disabled
        />
        <label for={props.age.name}>{props.age.label}</label>
      </div>

      <div class="form-floating mb-3 form-group" key={props.birthdate['id']}>
        <input
          type={props.birthdate.type}
          class="form-control input"
          id={props.birthdate.name}
          name={props.birthdate.name}
          placeholder={props.birthdate.placeholder}
          value={birthday.value}
          onInput={handleChange}
          data-validator={props.birthdate.validator}
        />
        <label for={props.birthdate.name}>{props.birthdate.label}</label>
      </div>
    </Fragment>
  );
};

export default Birthdate;
